import { observer } from "mobx-react";
import { DownloadPromptCopy } from "../../shared/interfaces/team";
import { downloadPromptText } from "../../utils/downloadPromptCopy";
import {
  SharingLaterButton,
  SharingPopupBody,
  SharingPopupCard,
  SharingPopupHeadline,
  SharingPopupImage,
  SharingPopupOverlay,
  SharingPrimaryButton,
  SharingSecondaryButton,
} from "./styled";

interface Props {
  teamColor?: string;
  copy?: DownloadPromptCopy;
  imageUrl?: string;
  onShare: () => void;
  onCopyLink: () => void;
  onLater: () => void;
}

const FanSharingPromptPopup = observer(({
  teamColor,
  copy,
  imageUrl,
  onShare,
  onCopyLink,
  onLater,
}: Props): JSX.Element => (
  <SharingPopupOverlay>
    <SharingPopupCard role="dialog" aria-labelledby="fan-sharing-prompt-title">
      {imageUrl ? <SharingPopupImage src={imageUrl} alt="" /> : null}
      <SharingPopupHeadline id="fan-sharing-prompt-title">
        {downloadPromptText(copy, "shareHeadline")}
      </SharingPopupHeadline>
      <SharingPopupBody>
        {downloadPromptText(copy, "shareBody")}
      </SharingPopupBody>
      <SharingPrimaryButton type="button" $teamColor={teamColor} onClick={onShare}>
        Share My Photo
      </SharingPrimaryButton>
      <SharingSecondaryButton type="button" $teamColor={teamColor} onClick={onCopyLink}>
        Copy Link
      </SharingSecondaryButton>
      <SharingLaterButton type="button" onClick={onLater}>
        Maybe Later
      </SharingLaterButton>
    </SharingPopupCard>
  </SharingPopupOverlay>
));

export default FanSharingPromptPopup;
